module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-3500-Classes-Active-f8771cdec846b7342094da22313f9d36.png";